import { z } from 'zod';

/** Stable error codes. The web client switches on these, never on the message. */
export const ERROR_CODES = [
  'bad_request',
  'unauthorized',
  'forbidden',
  'not_found',
  'conflict',
  'version_conflict',
  'rate_limited',
  'ai_quota_exceeded',
  'ai_unavailable',
  'entitlement_required',
  'internal',
] as const;
export type ErrorCode = (typeof ERROR_CODES)[number];

export const apiErrorSchema = z.object({
  code: z.enum(ERROR_CODES),
  message: z.string(),
  details: z.unknown().optional(),
  requestId: z.string().optional(),
});
export type ApiError = z.infer<typeof apiErrorSchema>;

export const HTTP_STATUS_BY_CODE: Record<ErrorCode, number> = {
  bad_request: 400,
  unauthorized: 401,
  forbidden: 403,
  not_found: 404,
  conflict: 409,
  version_conflict: 409,
  rate_limited: 429,
  ai_quota_exceeded: 429,
  ai_unavailable: 503,
  entitlement_required: 402,
  internal: 500,
};

export const API_BASE_PATH = '/v1';
